import { createValidIcon } from '@ui/icons/utils/type-helper'

export const StarIcon = createValidIcon((props) => {
  const { size = 24, color = 'text-med-em' } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M10.6388 2.56592C11.158 1.44039 12.7246 1.40406 13.3097 2.45947L13.3634 2.56592L15.7775 7.80029L21.504 8.47998C22.7768 8.63131 23.2826 10.2033 22.3448 11.0708L18.1115 14.9858L19.2365 20.6411C19.4854 21.8942 18.1513 22.8688 17.0323 22.2427L12.0011 19.4263L6.96985 22.2417C5.85498 22.8658 4.51583 21.8989 4.76575 20.6411L5.88879 14.9858L1.65637 11.0708C0.716624 10.2017 1.22708 8.63069 2.49817 8.47998L8.22375 7.80029L10.6388 2.56592ZM9.92297 8.89307C9.70372 9.36841 9.2533 9.69305 8.73743 9.75439L3.80872 10.3384L7.45325 13.7075C7.83776 14.0632 8.0064 14.5919 7.9054 15.1011L6.93762 19.9673L11.2687 17.5444L11.4435 17.4614C11.8004 17.3182 12.2 17.3168 12.5587 17.4604L12.7335 17.5444L17.0626 19.9683L16.0968 15.1011C15.9954 14.5905 16.1651 14.0625 16.549 13.7075L20.1915 10.3384L15.2638 9.75439C14.7443 9.69265 14.297 9.36505 14.0792 8.89307L12.0011 4.38721L9.92297 8.89307Z'
        fill={color}
      />
    </svg>
  )
})
